import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { SHOPPING_AIDS } from "./shoppingAidsJson";
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";


function ShoppingAids(props) {


  return (
    <>
      <Helmet>
        <title>Luxury Shopping Aids - Store Display Products | Lussopack</title>
        <meta name="description" content="We make every piece of jewelry shine in your store with customizable shopping aids, including stacking jewelry trays, custom-made mirrors, and tissue boxes." />
        <meta name="keywords" content="shopping aids" />
        <link rel="canonical" href="https://lussopack.com/packaging/" />  
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Shopping Aids"}
        isShowOurReference={true}
      />
      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="shoppingAid">
              <h2 className="text-center">Shopping Aids</h2>
              <div className="shoppingAidsList">
              {
                SHOPPING_AIDS.map((shoppingAid, index)=>(
                  <div className={`shoppingAidsItem`} key={index}>
                    <Link to={toRoute(shoppingAid.path)}>
                      <Image
                        src={asset(`${shoppingAid.itemImageDesktop}`)}
                        alt={`${shoppingAid.item}`}
                        className="img-fluid zoom"
                        width="345"
                        height="345"
                      />
                    </Link>
                    <Link to={toRoute(shoppingAid.path)}>
                      <p className="text-center mt-2">{shoppingAid.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
              <div className="firstContainer">
                <p>We recognize that an elegantly decorated store plays in capturing the gaze of discerning customers. Our expertise lies in producing captivating shopping aids tailored specifically for jewelers. Our well designed mirror and presentation trays are curated to accentuate the value of your gems and improve your retail visibility.</p>    
                <p>We enable our customers to create an air of charm within their store, ensuring that each visit becomes a mesmerizing journey into the world of timeless elegance. Nourish your retail space with our thoughtfully crafted luxury shopping aids and transform every shopper's encounter into an unforgettable sensory delight.</p>
              </div>

              <div className="lastContainer">
                <h3>Lussopack's customization services</h3>
                <p>Elevate your shopping aids with our customization services. We provide a diverse array of options, allowing you to design a shopping assistant that aligns with your brand's image.When it comes to our jewelry display trays, you have full control over elements like colors, materials, and interiors, ensuring a personalized touch.</p>
              </div>
          </div>
        </Media>
        <Media lessThan="md">
          <div id="shoppingAidMobile">
              <h2>Shopping Aids</h2>
              <div className="shoppingAidsList">
              {
                SHOPPING_AIDS.map((shoppingAid, index)=>(
                  <div className={`shoppingAidsItem`} key={index}>
                    <Link to={toRoute(shoppingAid.path)}>
                      <Image
                        src={asset(`${shoppingAid.itemImageDesktop}`)}
                        alt={`${shoppingAid.item}`}
                        className="img-fluid"
                        width="345"
                        height="345"
                      />
                      <p>{shoppingAid.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
              <div className="firstContainer">
                <p>We recognize that an elegantly decorated store plays in capturing the gaze of discerning customers. Our expertise lies in producing captivating shopping aids tailored specifically for jewelers. Our well designed mirror and presentation trays are curated to accentuate the value of your gems and improve your retail visibility.</p>    
                <p>We enable our customers to create an air of charm within their store, ensuring that each visit becomes a mesmerizing journey into the world of timeless elegance. Nourish your retail space with our thoughtfully crafted luxury shopping aids and transform every shopper's encounter into an unforgettable sensory delight.</p>
              </div>

              <div className="lastContainer">
                <h3>Lussopack's customization services</h3>
                <p>Elevate your shopping aids with our customization services. We provide a diverse array of options, allowing you to design a shopping assistant that aligns with your brand's image.When it comes to our jewelry display trays, you have full control over elements like colors, materials, and interiors, ensuring a personalized touch.</p>
              </div>
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default ShoppingAids;
